import { render, staticRenderFns } from "./user-fortune-coin.vue?vue&type=template&id=52e30f63&scoped=true&"
import script from "./user-fortune-coin.vue?vue&type=script&lang=js&"
export * from "./user-fortune-coin.vue?vue&type=script&lang=js&"
import style0 from "./user-fortune-coin.vue?vue&type=style&index=0&id=52e30f63&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e30f63",
  null
  
)

export default component.exports